import { useState, useEffect } from "react";
import { format } from "date-fns/format";
import { de as LocaleDe } from "date-fns/locale/de";
import { fr as LocaleFr } from "date-fns/locale/fr";
import { es as LocaleEs } from "date-fns/locale/es";
import { it as LocaleIt } from "date-fns/locale/it";
import { nl as LocaleNl } from "date-fns/locale/nl";
import { enUS as LocaleEn } from "date-fns/locale/en-US";
import { useLocale } from "../../../../I18n";
import { dateFormats } from "../../../../../strings";
var useFormattedDate = function(date) {
    var language = useLocale().language;
    var dateLocale = {
        de: LocaleDe,
        fr: LocaleFr,
        es: LocaleEs,
        it: LocaleIt,
        nl: LocaleNl,
        en: LocaleEn
    }[language];
    var localDateFormats = dateFormats[language];
    var ref = useState(""), formattedDate = ref[0], setFormattedDate = ref[1];
    useEffect(function() {
        if (date) {
            var localDate = format(date, localDateFormats.dayDateLongYear, {
                locale: dateLocale
            });
            setFormattedDate(localDate);
        }
    }, [
        date,
        dateLocale,
        localDateFormats.dayDateLongYear
    ]);
    return formattedDate;
};
export { useFormattedDate };
